import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=6e2fe63d"
import script from "./AgentEdit.vue?vue&type=script&lang=js"
export * from "./AgentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports